import React, { useRef, useState, useCallback } from 'react';
import { MoveHorizontal } from 'lucide-react';

const BeforeAfterSlider = ({ beforeUrl, afterUrl, beforeLabel = 'Avant', afterLabel = 'Après' }) => {
  const containerRef = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);

  const setFromClientX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    setFromClientX(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging.current) setFromClientX(e.clientX);
  };
  const stop = () => {
    dragging.current = false;
  };
  const onKeyDown = (e) => {
    if (e.key === 'ArrowLeft') setPos((p) => Math.max(0, p - 4));
    if (e.key === 'ArrowRight') setPos((p) => Math.min(100, p + 4));
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[4/3] overflow-hidden rounded-xl select-none cursor-ew-resize bg-slate-100 border border-slate-200"
      data-testid="before-after-slider"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
    >
      {/* After image (base layer) */}
      <img src={afterUrl} alt={afterLabel} draggable={false} className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
      {pos < 86 && (
        <span className="absolute top-3 right-3 bg-black/60 text-white text-xs font-semibold px-2.5 py-1 rounded-full pointer-events-none">
          {afterLabel}
        </span>
      )}

      {/* Before image (clipped overlay) */}
      <img
        src={beforeUrl}
        alt={beforeLabel}
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      {pos > 14 && (
        <span className="absolute top-3 left-3 bg-black/60 text-white text-xs font-semibold px-2.5 py-1 rounded-full pointer-events-none">
          {beforeLabel}
        </span>
      )}

      {/* Divider + handle */}
      <div className="absolute top-0 bottom-0" style={{ left: `${pos}%`, transform: 'translateX(-50%)' }}>
        <div className="w-0.5 h-full bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.25)]" />
        <button
          type="button"
          onKeyDown={onKeyDown}
          aria-label="Déplacer le comparateur avant / après"
          data-testid="before-after-handle"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white shadow-lg flex items-center justify-center cursor-ew-resize focus:outline-none focus:ring-2 focus:ring-emerald-500"
        >
          <MoveHorizontal className="h-5 w-5 text-slate-700" />
        </button>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
